module.exports = __webpack_public_path__ + "media/images/icons/icon-how-it-works-47fc2525cf6281ef57f3f4840498cf27.svg";